var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 14,
    viewBox: "0 0 8 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.734 12.324a1 1 0 01-1.384 1.439l-.09-.087L.14 6.998 6.26.324a1 1 0 011.553 1.254l-.08.098-4.88 5.322 4.88 5.326z",
    fill: "#20303C"
  })));
}

export default "data:image/svg+xml,%3csvg width='8' height='14' viewBox='0 0 8 14' fill='none' xmlns='http://www.w3.org/2000/svg'%3e %3cpath fill-rule='evenodd' clip-rule='evenodd' d='M7.73384 12.3244C8.10697 12.7316 8.07936 13.3641 7.67218 13.7373C7.29632 14.0817 6.72842 14.0847 6.3498 13.7628L6.25931 13.6756L0.140007 6.9978L6.25953 0.32416C6.63279 -0.0828977 7.26536 -0.110296 7.67242 0.262963C8.04817 0.60751 8.10042 1.17301 7.81265 1.57813L7.73362 1.67585L2.85358 6.99801L7.73384 12.3244Z' fill='%2320303C'/%3e %3c/svg%3e";
export { SvgArrowLeft as ReactComponent };